module.exports = __webpack_public_path__ + "static/media/emot4_on.34374f95.svg";